import { render, staticRenderFns } from "./GetJWT.vue?vue&type=template&id=2985e6bc&scoped=true&"
import script from "./GetJWT.vue?vue&type=script&lang=js&"
export * from "./GetJWT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2985e6bc",
  null
  
)

export default component.exports